/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IGenericPopupProps } from './generic-popup.props.autogenerated';

import classnames from 'classnames';
import Cookies from 'universal-cookie';

export interface IGenericPopupState {
    popupVisible: boolean;
    recallVisible: boolean;
}

export interface IGenericPopupViewProps extends IGenericPopupProps<{}>, IGenericPopupState {
    onDismissRecall(): void;
    onDismissPopup(): void;
    handleTextRecall(): void;
    classNamePopup: string;
    classNameRecall: string;
}

/**
 *
 * GenericPopup component
 * @extends {React.PureComponent<IGenericPopupProps<IGenericPopupState>>}
 */
class GenericPopup extends React.PureComponent<IGenericPopupProps<{}>, IGenericPopupState> {
    public state: IGenericPopupState = {
        popupVisible: false,
        recallVisible: false
    };

    public render(): JSX.Element | null {
        // const { closeButtonAriaLabel, closeButtonLabel } = this.props.resources;
        const { className } = this.props.config;
        const { popupVisible, recallVisible } = this.state;

        const viewProps = {
            ...this.props,
            classNamePopup: classnames('venchi_popup'),
            classNameRecall: classnames('venchi-recall', 'slide-in', className),
            popupVisible, // State data
            recallVisible, // State data
            onDismissRecall: this._onDismissRecall, // Methods
            onDismissPopup: this._onDismissPopup, // Methods
            handleTextRecall: this._displayPopupNow
        };

        return this.props.renderView(viewProps) as React.ReactElement;
    }

    private readonly _onDismissRecall = (): void => {
        this.createCookieRecall();
        this.setState({ recallVisible: false });
    };

    private readonly _onDismissPopup = (): void => {
        if (this.props.config.recallEnabled || false) {
            switch (this.props.config.recallShowAfterPopup) {
                case 'afterPopup':
                    setTimeout(this._displayRecallNow, 3000);
                    break;
                case 'afterPageReload':
                default:
                    break;
            }
        }
        this.setState({
            popupVisible: false
        });
    };

    private readonly _displayRecallNow = (): void => {
        this.setState({
            popupVisible: false,
            recallVisible: true
        });
    };

    private readonly _displayPopupNow = (): void => {
        if (this.props.config.cookieCheckbox) {
            this.createCookie();
        }
        this.setState({
            popupVisible: true,
            recallVisible: false
        });
    };

    public async componentDidMount() {
        const cookie = new Cookies();
        if (this.props.config.hidePopupIfCookieIsSet) {
            if (!cookie.get(`${this.props.config.modalId}-shown`)) {
                setTimeout(this._displayPopupNow, 1000 * (this.props.config.delayPopup || 0));
            } else {
                if (this.props.config.recallEnabled && !cookie.get(`${this.props.config.modalId}-recall-hidden`)) {
                    setTimeout(this._displayRecallNow, 1000 * (this.props.config.delayRecall || 0));
                }
            }
        } else {
            setTimeout(this._displayPopupNow, 1000 * (this.props.config.delayPopup || 0));
        }
    }

    private createCookie() {
        const cookie = new Cookies();
        // @ts-ignore
        if (this.props.config.expireDays >= 1) {
            var date = new Date();
            // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
            // @ts-ignore
            date.setDate(date.getDate() + (this.props.config.expireDays || 0));
            const options = { expires: date };
            cookie.set(`${this.props.config.modalId}-shown`, true, options);
        } else {
            cookie.set(`${this.props.config.modalId}-shown`, true);
        }
    }

    private createCookieRecall() {
        const cookie = new Cookies();
        // @ts-ignore
        if (this.props.config.recallDismissableForDays >= 1) {
            var date = new Date();
            // @ts-ignore
            date.setDate(
                // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
                date.getDate() + (this.props.config.recallDismissableForDays || 0)
            );
            const options = { expires: date };
            cookie.set(`${this.props.config.modalId}-recall-hidden`, true, options);
        } else {
            cookie.set(`${this.props.config.modalId}-recall-hidden`, true);
        }
    }
}

export default GenericPopup;
